export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";